// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssetClassFromJSON, AssetClassToJSON, CompositionRulesFromJSON, CompositionRulesToJSON, PortfolioAssetFromJSON, PortfolioAssetToJSON, } from './';
export function PortfolioFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ticker': !exists(json, 'ticker') ? undefined : json['ticker'],
        'assetClasses': !exists(json, 'assetClasses') ? undefined : json['assetClasses'].map(AssetClassFromJSON),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'compositionRules': !exists(json, 'compositionRules') ? undefined : CompositionRulesFromJSON(json['compositionRules']),
        'referenceDate': !exists(json, 'referenceDate') ? undefined : new Date(json['referenceDate']),
        'portfolioAssets': !exists(json, 'portfolioAssets') ? undefined : json['portfolioAssets'].map(PortfolioAssetFromJSON),
        'portfolioStartDate': !exists(json, 'portfolioStartDate') ? undefined : new Date(json['portfolioStartDate']),
        'portfolioCreationDate': !exists(json, 'portfolioCreationDate') ? undefined : new Date(json['portfolioCreationDate']),
        'portfolioModificationDate': !exists(json, 'portfolioModificationDate') ? undefined : new Date(json['portfolioModificationDate']),
        'portfolioType': !exists(json, 'portfolioType') ? undefined : json['portfolioType'],
        'latestInvestorCfDate': !exists(json, 'latestInvestorCfDate') ? undefined : new Date(json['latestInvestorCfDate']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isAdminPortfolio': !exists(json, 'isAdminPortfolio') ? undefined : json['isAdminPortfolio'],
        'isPrivatePortfolio': !exists(json, 'isPrivatePortfolio') ? undefined : json['isPrivatePortfolio'],
        'userGroupId': !exists(json, 'userGroupId') ? undefined : json['userGroupId'],
        'userGroupName': !exists(json, 'userGroupName') ? undefined : json['userGroupName'],
        'isSynchronizedWithCentral': !exists(json, 'isSynchronizedWithCentral') ? undefined : json['isSynchronizedWithCentral'],
    };
}
export function PortfolioToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'ticker': value.ticker,
        'assetClasses': value.assetClasses === undefined ? undefined : value.assetClasses.map(AssetClassToJSON),
        'currency': value.currency,
        'compositionRules': CompositionRulesToJSON(value.compositionRules),
        'referenceDate': value.referenceDate === undefined ? undefined : value.referenceDate.toISOString(),
        'portfolioAssets': value.portfolioAssets === undefined ? undefined : value.portfolioAssets.map(PortfolioAssetToJSON),
        'portfolioStartDate': value.portfolioStartDate === undefined ? undefined : value.portfolioStartDate.toISOString(),
        'portfolioCreationDate': value.portfolioCreationDate === undefined ? undefined : value.portfolioCreationDate.toISOString(),
        'portfolioModificationDate': value.portfolioModificationDate === undefined ? undefined : value.portfolioModificationDate.toISOString(),
        'portfolioType': value.portfolioType,
        'latestInvestorCfDate': value.latestInvestorCfDate === undefined ? undefined : value.latestInvestorCfDate.toISOString(),
        'description': value.description,
        'isAdminPortfolio': value.isAdminPortfolio,
        'isPrivatePortfolio': value.isPrivatePortfolio,
        'userGroupId': value.userGroupId,
        'userGroupName': value.userGroupName,
        'isSynchronizedWithCentral': value.isSynchronizedWithCentral,
    };
}
